<template>
  <div class="relative whitespace-nowrap" :data-rating="indicator">
    <div class="flex items-center text-[32px] gap-[1px]">
      <i class="ga-icon ga-star_sharp text-secondary text-md"></i>
      <i class="ga-icon ga-star_sharp text-secondary text-md"></i>
      <i class="ga-icon ga-star_sharp text-secondary text-md"></i>
      <i class="ga-icon ga-star_sharp text-secondary text-md"></i>
      <i class="ga-icon ga-star_sharp text-secondary text-md"></i>
    </div>
    <div
      class="flex items-center text-[32px] gap-[1px] absolute top-0 left-0 overflow-hidden whitespace-nowrap"
      :style="'width:' + indicator + '%'">
      <i class="ga-icon ga-star_filled text-secondary text-md"></i>
      <i class="ga-icon ga-star_filled text-secondary text-md"></i>
      <i class="ga-icon ga-star_filled text-secondary text-md"></i>
      <i class="ga-icon ga-star_filled text-secondary text-md"></i>
      <i class="ga-icon ga-star_filled text-secondary text-md"></i>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RatingStar',
  props: {
    indicator: {
      type: Number,
      required: true,
    },
  },
};
</script>
